/**
 * EN / ES copy for the post-Calendly thank-you page.
 * Imported and merged into the main translations object.
 *
 * `byType` keys match the booking types in src/lib/bookingTypes.ts; the page
 * falls back to the generic copy when no (or an unknown) type is present.
 */
export const thankYouTranslations = {
  en: {
    calendlyThankYou: {
      badge: "Booking confirmed",
      greeting: "Thanks, {name}!",
      genericGreeting: "Thanks for booking!",
      withLabel: "With",
      whenLabel: "When",
      nextStepsTitle: "What happens next",
      nextSteps: [
        "You'll get a calendar invite and confirmation email in the next few minutes.",
        "We'll take a quick look at your business before we meet.",
        "On the call we'll talk through what takes up your team's time and what we could take off your plate.",
      ],
      inboxNote:
        "Don't see the email? Check your spam folder, or reply to any of our emails and we'll resend it.",
      rescheduleNote:
        "Need to reschedule or cancel? Use the links in your confirmation email.",
      backHome: "Back to Home",
      exploreServices: "Explore our services",
      byType: {
        free_consultation: {
          title: "Your free 20-minute intro call is confirmed",
          message: "We'll learn about your business and where we can save you time.",
        },
        lead_leak_review: {
          title: "Your Lead Leak Review is confirmed",
          message:
            "We'll dig into your calls, forms, and follow-up process, then walk you through what we find and what to fix first.",
        },
        lead_recovery_setup: {
          title: "Your setup consultation is confirmed",
          message:
            "We'll map out the automations to install around your existing tools and agree on a timeline for going live.",
        },
        monthly_management: {
          title: "Your monthly management call is confirmed",
          message:
            "We'll go over the support you need each month and how we'd keep your system running and improving.",
        },
        generic: {
          title: "Your call is confirmed",
          message:
            "We're looking forward to speaking with you. Everything you need is in your confirmation email.",
        },
      },
    },
  },
  es: {
    calendlyThankYou: {
      badge: "Reserva confirmada",
      greeting: "¡Gracias, {name}!",
      genericGreeting: "¡Gracias por agendar!",
      withLabel: "Con",
      whenLabel: "Cuándo",
      nextStepsTitle: "Qué sigue",
      nextSteps: [
        "Recibirás la invitación de calendario y un correo de confirmación en los próximos minutos.",
        "Echaremos un vistazo a tu negocio antes de la reunión.",
        "En la llamada hablaremos de lo que le quita tiempo a tu equipo y qué podemos resolver por ti.",
      ],
      inboxNote:
        "¿No ves el correo? Revisa tu carpeta de spam o respóndenos y te lo reenviamos.",
      rescheduleNote:
        "¿Necesitas reprogramar o cancelar? Usa los enlaces de tu correo de confirmación.",
      backHome: "Volver al Inicio",
      exploreServices: "Ver nuestros servicios",
      byType: {
        free_consultation: {
          title: "Tu llamada introductoria gratuita de 20 minutos está confirmada",
          message: "Conoceremos tu negocio y dónde podemos ahorrarte tiempo.",
        },
        lead_leak_review: {
          title: "Tu Revisión de Fugas de Leads está confirmada",
          message:
            "Analizaremos tus llamadas, formularios y proceso de seguimiento, y te mostraremos qué encontramos y qué corregir primero.",
        },
        lead_recovery_setup: {
          title: "Tu consulta de instalación está confirmada",
          message:
            "Definiremos las automatizaciones a instalar sobre tus herramientas actuales y acordaremos un plan para salir en vivo.",
        },
        monthly_management: {
          title: "Tu llamada de gestión mensual está confirmada",
          message:
            "Repasaremos el soporte que necesitas cada mes y cómo mantendríamos tu sistema funcionando y mejorando.",
        },
        generic: {
          title: "Tu llamada está confirmada",
          message:
            "Tenemos muchas ganas de hablar contigo. Todo lo que necesitas está en tu correo de confirmación.",
        },
      },
    },
  },
};
